<input #searchInput [type]="type" [autocomplete]="autocomplete" [placeholder]="placeholder" [formControl]="control">{{text}}
<fa-icon *ngIf="type === 'password' && !displayPass" [icon]="faEye" class="eye" (click)="togglePass()"></fa-icon>
<fa-icon *ngIf="type === 'text' && orgType === 'password' && displayPass" [icon]="faEyeSlash" class="eye" (click)="togglePass()"></fa-icon>  
